/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { sharedListPagesFilterStyle } from "@monsma/App/WidgetExtensions/MyAccount/MyAccountListPagesExtension";
import { css } from "styled-components";

filterStyles.container = sharedListPagesFilterStyle.container;

filterStyles.headingGridItem = {
    css: css`
        display: none;
    `,
};

filterStyles.shipToGridItem = sharedListPagesFilterStyle.normalGridItem;

filterStyles.orderNumberGridItem = sharedListPagesFilterStyle.normalGridItem;

filterStyles.datesGridItem = sharedListPagesFilterStyle.normalGridItem;

filterStyles.datesContainer = sharedListPagesFilterStyle.customContainer;

filterStyles.fromGridItem = sharedListPagesFilterStyle.dateGridItem;

filterStyles.toGridItem = sharedListPagesFilterStyle.dateGridItem;

filterStyles.orderTotalGridItem = sharedListPagesFilterStyle.normalGridItem;

filterStyles.orderTotalContainer = sharedListPagesFilterStyle.customContainer;

filterStyles.orderTotalOperatorGridItem = {
    width: [12, 6, 6, 6, 6],
};

filterStyles.orderTotalAmountGridItem = {
    ...filterStyles.orderTotalOperatorGridItem,
    css: css`
        align-items: flex-end;
    `,
};

filterStyles.orderTotalAmountTextField = {};

filterStyles.buttonsItem = sharedListPagesFilterStyle.buttonsItem;

filterStyles.clearFiltersButton = sharedListPagesFilterStyle.clearFiltersButton;
